import React from 'react';
import { connect } from 'react-redux';
import UnlockPremium from './UnlockPremium'
import { Modal, Button as AButton } from 'antd';
import { CheckIcon } from '../core/icons'

import {
  BrowserRouter as Router,
  Route,
  Link,
  Redirect
} from 'react-router-dom'

import styled from 'styled-components'

import { push, goBack } from 'react-router-redux'


export const Button = styled(AButton).attrs({
  type: props => props.primary && 'primary'
})`
  font-size: 18px;
  margin-top: 12px;

  ${props=>props.fullWidth&&`
    width: 100%;
    height: 42px;
  `}
`

const Body = styled.div`
  padding: 5vmin;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: large;
  h1 {
    font-size: 25px;
    text-transform: capitalize;

  }
  > ol {
    list-style: decimal;
    padding-left: 30px;
    li {
      font-size: 18px;
      margin-bottom: 5px;
      padding: 1vmin 0;
    }
  }
`

const VideoContainer = styled.div`
  width: 100%;
  height: 0;
  padding-bottom: 56.25%; //16 x 9
  position: relative;
  .player {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
  }

`

const DefaultModal = ({ dispatch, message, title }) => (
  <Modal
    size='large'
    bodyStyle={{padding: 0}}
    visible={true}
    width={'80vw'}
    // height={'80vw'}
    // onOk={() => dispatch({type:'HIDE_MODAL_2'})}
    onCancel={() => dispatch({type:'HIDE_MODAL_2'})}
    footer={null}
  >
    <Body>
      <h1>{title}</h1>
      <p>{message}</p>
      <VideoContainer>

        <iframe className="player" width="100%" height="100%" src="https://www.youtube.com/embed/70QBcLpgiCg?autoplay=true&rel=0&amp;controls=0&amp;showinfo=0" frameborder="0" allow="autoplay; encrypted-media"/>
      </VideoContainer>

      <Button primary onClick={() => dispatch({type:'HIDE_MODAL_2'})}>Get Started</Button>
    </Body>
  </Modal>

)

export default connect(
  // ownProps in this case are modalProps passed from the action or reducer
  (state, ownProps) => ({

  })
)(DefaultModal)



// WEBPACK FOOTER //
// ./src/modal/VideoModal.js